import {
    LOGOUT,
    O365_REGISTER_REQUEST,
    O365_REGISTER_SUCCESS,
    O365_REGISTER_FAILURE,
    BSRS_LOGIN_REQUEST,
    BSRS_LOGIN_SUCCESS,
    BSRS_LOGIN_FAILURE,
    PROFILE_LOGIN_REQUEST,
    PROFILE_LOGIN_SUCCESS,
    PROFILE_LOGIN_FAILURE,
    BSRS_SERVICE_TOKEN_REQUEST,
    BSRS_SERVICE_TOKEN_SUCCESS,
    BSRS_SERVICE_TOKEN_FAILURE,
} from '../../types'

import { setToken, clearBSRSToken, setBSRSToken, setServiceToken, CORE_API_ENDPOINT, getBSRSToken, setRoomToken } from 'Lib'
import { CALL_API } from 'Middlewares'

export function authorizeO365(code) {
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/o365/token`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ code }),
            types: [
                O365_REGISTER_REQUEST,
                {
                    type: O365_REGISTER_SUCCESS,
                    payload(action, state, res) {
                        return res.json()
                            .then(json => {
                                const {
                                    access_token,
                                    expires_on,
                                    refresh_token
                                } = json

                                const token = {
                                    access_token,
                                    expires_on,
                                    refresh_token
                                }

                                setToken(token)
                                return { token }
                            })
                    }
                },
                O365_REGISTER_FAILURE
            ]
        }
    }
}

export function authorizeProfile({ email, password }) {
    return {
        [CALL_API]: {
            endpoint: `https://www.bsrsprofile.com/center/profile/verify`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ email, password }),
            types: [
                PROFILE_LOGIN_REQUEST,
                {
                    type: PROFILE_LOGIN_SUCCESS,
                    payload(action, state, res) {
                        return res.json()
                            .then(json => {
                                const {
                                    room,
                                    appMeta
                                } = json.profile
                                const { client_id, api_server_url } = appMeta
                                setRoomToken(room, client_id, api_server_url)
                                return { room }
                            })
                    }
                },
                PROFILE_LOGIN_FAILURE
            ]
        }
    }
}

export function authorizeBSRS({ emailaddress, password }) {
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/user/adminverify`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ email: emailaddress, password }),
            types: [
                BSRS_LOGIN_REQUEST,
                {
                    type: BSRS_LOGIN_SUCCESS,
                    payload(action, state, res) {
                        return res.json()
                            .then(json => {
                                const {
                                    isIntegration,
                                    isUserActiveDirectory,
                                    token,
                                    user,
                                    company,
                                    companyCode,
                                    system_key
                                } = json
                                const { id, firstName, email } = user

                                let bsrsToken = {
                                    isIntegration, token, id, company, firstName, email, companyCode,
                                    isUserActiveDirectory: isUserActiveDirectory ? isUserActiveDirectory : false,
                                    system_key
                                }
                                setBSRSToken(bsrsToken)
                                return { bsrsToken }
                            })
                    },
                    callBack(data) {
                        const payload = data.payload
                        if (payload.bsrsToken) {
                            window.location.replace('/')
                        }
                    }
                },
                BSRS_LOGIN_FAILURE
            ]
        }
    }
}

export function authorizeServiceToken(history) {
    const bsrsToken = getBSRSToken()
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/o365/service_token`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${bsrsToken}`
            },
            types: [
                BSRS_SERVICE_TOKEN_REQUEST,
                {
                    type: BSRS_SERVICE_TOKEN_SUCCESS,
                    payload(action, state, res) {
                        return res.json()
                            .then(json => {
                                const {
                                    token,
                                    expires_on,
                                } = json
                                const serviceToken = {
                                    token,
                                    expires_on,
                                }
                                if (typeof token === 'undefined') history.push(`/settings/integration`)
                                else {
                                    setServiceToken(serviceToken)
                                    return { serviceToken }
                                }
                            })
                    },
                    callBack() {
                        // history.push(`/room`)
                    }
                },
                BSRS_SERVICE_TOKEN_FAILURE
            ]
        }
    }
}


export function logout() {
    clearBSRSToken()
    return {
        type: LOGOUT
    }
}


// WEBPACK FOOTER //
// ./src/features/auth/actions.js